import type { Channel } from "@/shared/model/channel";
import type { PotentialPayout } from "@/shared/model/potential-payout";
import type { PotentialPriceBreakdown } from "@/shared/model/potential-price-breakdown";
import { Status } from "@/shared/model/enums/status";
import type { PotentialPrice } from "@/shared/model/potential-price";
import { TicketLeg } from "./ticket";
import { BonusInfo } from "@/shared/model/bonus-info";

export enum BetType {
    OPEN = "open",
    SETTLED = "settled",
    CASHOUT = "cashout",
}
export class BetTypeRef {
    static SINGLE = "SGL";
    static DOUBLE = "DBL";
    static TRIPLE = "TBL";
    static KOMBI = "BYOS";
    static AKO(count: number): string {
        return `ACCUMULATOR${count}`;
    }
}

export interface Bet {
    documentId: string;
    betTypeRef: string; // enum?
    text: string;
    status: Status;
    lines: number;
    legRefs: string[];
    potentialPayout: PotentialPayout[];
    maximumPayout: string;
    minimumStake: string;
    maximumStake: string;
    optionsAvailable: {
        winPlaceOverrideOptions: string[]; // enum array?
        retailCapture: {
            channels: Channel[];
        };
    };
    systemBets: SystemBet[];
}

export interface SystemBet extends Pick<Bet, "betTypeRef" | "lines" | "potentialPayout"> {
    potentialPriceBreakdown: PotentialPriceBreakdown[];
    stake?: string;
    stakePerLine?: string;
}

export interface Cashout {
    customerId: string;
    status: string;
    value: string;
    available: boolean;
    betPlacedTime: string;
    cashoutCalculationTime: string;
}

export interface BetData {
    betActionHistory: []; // ???
    betTypeRef: string;
    bonusInfo?: BonusInfo;
    cashout?: Cashout;
    channel: string; // enum??
    id: string;
    isSettled: boolean;
    legs: TicketLeg[];
    name: string;
    numLines: number;
    placedDate: string;
    poll?: boolean;
    pollPeriod?: number;
    potentialPayout?: string;
    potentialPrice: PotentialPrice;
    receipt: string;
    refunds?: string;
    settledDate?: string;
    stake: string;
    stakePerLine?: string;
    status: string; // enum?
    systemBets?: SystemBet[];
    tax?: string;
    tokenStake: string;
    winnings?: string;
}

export interface BetsDataWithPaginationToken {
    data: BetData[];
    paginationToken: string;
}
